import { cn } from '@/platform/lib/utils';

const addonClasses =
    'flex shrink-0 items-center text-sm whitespace-nowrap text-gray-500 select-none';

const FilterBarInput = ({
    type = 'text',
    value,
    onChange,
    prefix,
    suffix,
    className,
    ...props
}) => (
    <label
        className={cn(
            'flex cursor-text items-center gap-2 px-4 focus-within:bg-gray-50',
            className
        )}
    >
        {prefix && <span className={addonClasses}>{prefix}</span>}
        <input
            type={type}
            value={value ?? ''}
            onChange={event => onChange?.(event.target.value)}
            className='h-12 w-20 min-w-0 flex-1 border-0 bg-transparent p-0 text-sm shadow-none outline-none placeholder:text-gray-400 focus:border-0 focus:ring-0'
            {...props}
        />
        {suffix && <span className={addonClasses}>{suffix}</span>}
    </label>
);

export default FilterBarInput;
